/**
 * Role values are defined in: https://github.com/Clarifai/clarifai/blob/master/go/src/clarifai/constants/roles/roles.go
 */
export const ORGANIZATION_ROLE_ID_ADMIN = 'org-owner';

export const ORGANIZATION_ROLE_ID_MEMBER = 'org-member';

export const ORGANIZATION_ROLE_ID_MEMBER_MIN = 'org-member-min-access-role';

export const ORGANIZATION_ROLE_ID_FINANCIAL_MANAGER = 'org-financial-manager';

export const ORGANIZATION_ROLE_ID_ORG_USER = 'org-user';

export const ORGANIZATION_ROLE_ID_INFRASTRUCTURE_MANAGER = 'org-infrastructure-manager';

export type RolesT =
  | typeof ORGANIZATION_ROLE_ID_ADMIN
  | typeof ORGANIZATION_ROLE_ID_MEMBER
  | typeof ORGANIZATION_ROLE_ID_MEMBER_MIN
  | typeof ORGANIZATION_ROLE_ID_FINANCIAL_MANAGER
  | typeof ORGANIZATION_ROLE_ID_ORG_USER
  | typeof ORGANIZATION_ROLE_ID_INFRASTRUCTURE_MANAGER;

export const ESSENTIAL_PLAN_ID = 'developer-plan';

export const PROFESSIONAL_PLAN_ID = 'professional-plan';

export const COMMUNITY_PLAN_ID = 'community-plan';

export const ENTERPRISE_PLAN_ID = 'enterprise-plan';

export const INTERNAL_PLAN_ID = 'internal-plan';

export const TEAM_ROLE_TYPE = 0 as CF.API.Organizations.TeamRoleType;

export const ORG_ROLE_TYPE = 1 as CF.API.Organizations.OrgRoleType;

/**
 * Maximum number of organizations a user can create. For Internal users, its unlimited.
 */
export const getMaxOrganizations = (isInternalUser: boolean = false) => (isInternalUser ? Number.MAX_SAFE_INTEGER : 20);

export const ORG_ROLE_DESCRIPTIONS: Record<RolesT, string> = {
  [ORGANIZATION_ROLE_ID_ADMIN]: 'Full access including member management',
  [ORGANIZATION_ROLE_ID_MEMBER]: 'Full access to all apps',
  [ORGANIZATION_ROLE_ID_MEMBER_MIN]: 'Limited access to assigned apps',
  [ORGANIZATION_ROLE_ID_FINANCIAL_MANAGER]: 'Access to financial data',
  [ORGANIZATION_ROLE_ID_ORG_USER]: 'Read-only access to all apps',
  [ORGANIZATION_ROLE_ID_INFRASTRUCTURE_MANAGER]: 'Manage dedicated compute clusters',
};

export const DOCUMENTATION_ORG_ROLES_LINK = 'https://docs.clarifai.com/control/clarifai-organizations/members-teams#roles-for-members';
